<template>
  <div
    :class="[
      'tw-rounded-[30px] tw-p-8 tw-flex tw-flex-col tw-transition-transform tw-duration-300',
      tier.featured ? 'md:tw-scale-105 tw-z-10' : 'tw-bg-white',
    ]"
    :style="tier.featured
      ? 'background-color: #2d6f41; padding-top: 2.5rem; padding-bottom: 2.5rem; box-shadow: 0 8px 32px rgba(0,0,0,0.18);'
      : 'box-shadow: 0 4px 20px rgba(0,0,0,0.10);'"
  >
    <p
      :class="tier.featured ? 'tw-text-white' : 'tw-text-black'"
      style="font-family: 'Roboto', sans-serif; font-size: 0.95rem; font-weight: 400; min-height: 3rem;"
    >
      {{ tier.name }}
    </p>
    <div class="tw-flex tw-items-baseline tw-gap-1 tw-mt-3 tw-mb-5">
      <span
        :style="tier.featured ? 'color: white;' : 'color: #2d6f41;'"
        style="font-family: 'Roboto', sans-serif; font-size: 2.8rem; font-weight: 500; line-height: 1;"
      >{{ tier.priceMonthly }}</span>
      <span
        :class="tier.featured ? 'tw-text-white' : 'tw-text-gray-500'"
        style="font-family: 'Roboto', sans-serif; font-size: 0.95rem;"
      >/month</span>
    </div>
    <ul class="tw-space-y-2 tw-mb-6 tw-flex-1">
      <li
        v-for="feature in tier.features"
        :key="feature"
        class="tw-flex tw-items-start tw-gap-2"
        :style="tier.featured ? 'color: white;' : 'color: black;'"
        style="font-family: 'Roboto', sans-serif; font-size: 0.875rem;"
      >
        <v-icon size="18" :color="tier.featured ? 'white' : '#2d6f41'" class="tw-mt-0.5 tw-flex-shrink-0">mdi-check</v-icon>
        {{ feature }}
      </li>
    </ul>
    <component
      :is="tier.is_coming ? 'div' : 'router-link'"
      :to="tier.is_coming ? undefined : tier.href"
      class="tw-mt-auto tw-block"
    >
      <v-btn
        rounded="pill"
        size="default"
        block
        :disabled="tier.is_coming"
        :style="tier.featured
          ? 'background-color: white; color: #2d6f41; text-transform: none; font-family: Roboto, sans-serif; font-size: 0.95rem; letter-spacing: 0;'
          : 'background-color: #2d6f41; color: white; text-transform: none; font-family: Roboto, sans-serif; font-size: 0.95rem; letter-spacing: 0;'"
      >
        {{ tier.is_coming ? 'Coming Soon' : 'Get Started' }}
      </v-btn>
    </component>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue';

export interface Tier {
  id: string;
  name: string;
  description: string;
  priceMonthly: string;
  features: string[];
  featured: boolean;
  is_coming: boolean;
  href: string;
}

defineProps({
  tier: {
    type: Object as PropType<Tier>,
    required: true,
  },
});
</script>
